import React, { useContext } from "react";
import LinkCard from "./LinkCard";
import { Typography, Grid, Box } from "@material-ui/core";
import Loading from "../common/Loading";
import { AppContext } from "../../context/reducer";

const AppLinks = () => {
  const { state } = useContext(AppContext);
  return (
    <Box p={2}>
      <Typography variant="h4" gutterBottom style={{ paddingBottom: 20 }}>
        {window.t["Apps"]}
      </Typography>
      <Grid container spacing={4}>
        {state.loading ? (
          <Loading />
        ) : (
          <>
            {!state.apps.length && (
              <Grid item>
                <Typography variant="body2">
                  {window.t["No links were found"]}
                </Typography>
              </Grid>
            )}
            {state.apps.map((app, i) => (
              <Grid
                key={i}
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={window.AppInfo.showNews ? 3 : 2}
              >
                <LinkCard {...app} />
              </Grid>
            ))}
          </>
        )}
      </Grid>
    </Box>
  );
};

export default AppLinks;
